// Google analytics related constant.
export const gaMeasurementIDStaging = 'G-5DK59EDZNR';
export const gaMeasurementIDProduction = 'G-EPF1561YYW';

export const stagingEnv = 'stagingagents';
export const prodEnv = 'agents';

export const tabClickText = 'Tab Click';
export const buttonClickText = 'Button Click';
export const eventCategoryText = 'Event';
export const pageTypeText = 'Page';
export const pageViewText = 'pageview';

export const loginButtonClickedText = 'Login Button Clicked';
export const publishAgentButtonClickedText = 'Publish Agent Button Clicked';
export const findAgentButtonClickedText = 'Find Agent Button Clicked';
export const termsOfServiceLinkClickedText = 'Terms of Service Link Clicked';
export const privacyPolicyLinkClickedText = 'Privacy Policy Link Clicked';
export const downloadZipButtonClickedText = 'Download Zip Button Clicked';
export const changeAgentButtonClickedText = 'Change Agent Button Clicked';
export const askButtonClickedText = 'Ask Button Clicked';
export const fileUploadedText = 'File Uploaded';
export const publisherGuideDownloadClickedText = 'Publisher Guide Download Clicked';
export const howToCreateAgentLinkClickedText = 'How to Create Agent Link Clicked';
export const contactForDemoClickedText = 'Contact for demo clicked';
export const industryFilterChangedText = 'Industry Filter Changed';
export const readMoreClickedText = 'Read More clicked';
export const modalClosedText = 'Modal closed';
export const goButtonClickedText = 'Go Button Clicked';
export const agentSendClickedText = 'Agent Send Clicked';
export const agentDownloadClickedText = 'Agent Download Clicked';
export const agentSearchPerformedText = 'Agent Search Performed';
export const clearFiltersClickedText = 'Clear Filters Clicked';
export const moreDetailsLinkClickedText = 'More Details Link Clicked';
export const filterAppliedText = 'Filter Applied';
export const filterRemovedText = 'Filter Removed';
export const faqAccordionOpenedText = 'FAQ Accordion Opened: ';
export const faqAccordionClosedText = 'FAQ Accordion Closed: ';

export const logoClickedText = 'Logo Clicked';
export const homeTabClickedText = 'Home Tab Clicked';
export const publisherTabClickedText = 'Publisher Tab Clicked';
export const publisherGuideTabClickedText = 'Publisher Guide Tab Clicked';
export const agentsTabClickedText = 'Agents Tab Clicked';
export const appsTabClickedText = 'Apps Tab Clicked';
export const leaderboardTabClickedText = 'Leaderboard Tab Clicked';
export const logoutTabClickedText = 'Logout Tab Clicked';
export const drawerOpenedText = 'Drawer Opened';
export const drawerClosedText = 'Drawer Closed';
export const copyToClipboardClickedText = 'Copy To Clipboard Clicked';
export const sdkContentLink = 'SDK repository';
export const uuidContent = 'UUID Generator';
export const laipDocsLinkText = 'Content Link Clicked: LAIP docs';

// Leaderboard insights tabs
export const topPublishersTabClickedText = 'Top Publishers Tab Clicked';
export const topDownloadedAgentsTabClickedText = 'Top Downloaded Agents Tab Clicked';
export const topRatedAgentsTabClickedText = 'Top Rated Agents Tab Clicked';
export const domainTabClickedText = 'Domain Tab Clicked';
export const rolesSupportedTabClickedText = 'Roles Supported Tab Clicked';
export const cloudProvidersTabClickedText = 'Cloud Providers Tab Clicked';
